import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Authprovider } from "./contexts/authContext";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Authprovider>
      <App />
    </Authprovider>
  </React.StrictMode>
);
